import React from 'react';
import PropTypes from 'prop-types';
import {Redirect, Route} from "react-router-dom";
import {LOGIN_PATH} from "../../constant/routes";

const PrivateRoute = ({component: Child, authenticated, ...rest}) => (
    <Route
        {...rest}
        render={props =>
            authenticated ? (
                <Child {...props} />
            ) : (
                <Redirect
                    to={{
                        pathname: LOGIN_PATH
                    }}
                />
            )
        }
    />
);

PrivateRoute.propTypes = {
    path: PropTypes.string.isRequired,
    component: PropTypes.func.isRequired,
    authenticated: PropTypes.bool.isRequired
};

export default PrivateRoute;


// WEBPACK FOOTER //
// ./src/component/util/PrivateRoute.jsx